import {environment} from "../../../../environments/environment";

export class Token {

    public grant_type: string;
    public client_id: string;
    public client_secret: string;
    public username: string;
    public password: string;


    constructor(username: string,
                password: string) {
        this.grant_type = environment.grantType;
        this.client_id = environment.clientId;
        this.client_secret = environment.clientSecret;
        this.username = username;
        this.password = password;
    }
}
